import {
  Box, Container, Typography, useMediaQuery,

} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import UseTranslation from '../../../hooks/UseTranslation'
import loginBackSvg from '../../../images/loginBackSvg.svg'
import SEO from '../../../components/PageHelpers/SEO'
import { ReactComponent as ActionHistory } from '../../../images/ActionHistory.svg'
import appRoutes from '../../../services/AppRoutes'
import { selectNotificationActionHistory } from '../../../redux/features/notifications/notificationActionHistory/notificationActionHistorySlice'
import {
  getNotificationActionHistoryList,
} from '../../../redux/features/notifications/notificationActionHistory/notificationActionHistoryThunk'
import ActionHistoryCardList from './ActionHistoryCardList'
import SearchBarToggle from '../../../components/PageHelpers/SearchBarToggle'

import TitleWithCountV2 from '../../../components/PageHelpers/TitleWithCountV2'
import SearchBarV2 from '../../../components/PageHelpers/SearchBarV2'

const Index = () => {
  const [searchBarExpanded, setSearchBarExpanded] = useState(false)
  const notificationActionHistoryStore = useSelector(selectNotificationActionHistory)
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const { t } = UseTranslation()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(getNotificationActionHistoryList({ resetQueries: true }))
  }, [])

  return (
    <Box sx={styles.root}>
      <SEO
        title={t?.['Action History']}
        description={t?.['Action History']}
      />
      <Container maxWidth={false} sx={styles.container}>
        <Box sx={styles.wrapperContainer}>
          <Link to={`${appRoutes.NotificationInbox}`} style={styles.link}>
            <Box sx={styles.backLink}>
              <ArrowBackIosNewIcon />
              <Typography variant="p">{t?.['Back To Inbox']}</Typography>
            </Box>
          </Link>
          <Box sx={styles.headerContainer}>
            {isXsScreen && !searchBarExpanded && (
              <Link to={`${appRoutes.NotificationInbox}`} style={styles.link}>
                <Box sx={styles.xsBackLink}>
                  <ArrowBackIosNewIcon />
                </Box>
              </Link>
            )}
            {!searchBarExpanded && (
              <TitleWithCountV2
                store={notificationActionHistoryStore}
                title={t?.['Action History']}
                customCount={t?.Requests}
                icon={<ActionHistory />}
                iconSize="xl"
                textVariant="heading2"
                customStyle={styles.headerTitle}
              />
            )}

            <Box sx={isXsScreen && styles.filterWithSearch}>
              {isXsScreen && (
                <SearchBarToggle
                  customStyle={styles.xsSearchBar}
                  searchPlaceholder={t?.['Search By Request Details']}
                  actionToDispatch={getNotificationActionHistoryList}
                  expandedState={searchBarExpanded}
                  setExpandedState={setSearchBarExpanded}
                  sendQueryAsObject
                  actionProps={{ pageNumber: 0 }}
                />
              )}
            </Box>
          </Box>
        </Box>

        {!isXsScreen && (
          <SearchBarV2
            actionToDispatch={getNotificationActionHistoryList}
            searchPlaceholder={t?.['Search by Request Details']}
            customStyles={styles.searchBar}
            sendQueryAsObject
            actionProps={{ pageNumber: 0 }}
          />
        )}

        <ActionHistoryCardList />

      </Container>
      <Box component="img" src={loginBackSvg} alt="login img" sx={styles.backSvg} />
    </Box>
  )
}

const styles = {
  root: {
    display: 'flex',
    marginTop: { xs: '-10px', sm: '-29px' },
    paddingInline: { xs: '10px !important', sm: '18px !important', md: '24px !important' },
  },
  xsSearchBar: {
    '& .MuiTextField-root': {
      marginBottom: '-20px',
    },
    '& img': {
      marginBottom: '-15px',
    },
  },
  searchBar: {
    marginBottom: '10px !important',
    marginTop: '30px',
    '& svg': {
      width: '30px',
      height: '30px',
    },
  },
  wrapperContainer: {
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    backgroundColor: '#FFF',
    margin: {
      xs: '0px',
      sm: '0px 10px 10px 10px',
      md: '-50px 0px 20px 0px',
      lg: '-50px 0px 20px 0px',
    },
    height: { xs: '56px', sm: '88px' },
  },
  container: {
    padding: { xs: '0px !important', md: '52px 0px !important' },
  },
  filterWithSearch: {
    display: 'flex',
    gap: '5px',
    width: '100%',
    justifyContent: 'flex-end',
  },
  backLink: {
    display: { xs: 'none', sm: 'flex' },
    alignItems: 'center',
    textTransform: 'capitalize',
    color: '#90979E',
    textDecoration: 'none ',
    margin: '0',
    padding: '0',
    pt: '5px',
    fontSize: '12px',
    marginBottom: '5px',
    cursor: 'pointer',
    '& span': {
      margin: '0',
    },
    '& svg': {
      height: '11px',
    },
  },
  xsBackLink: {
    display: { xs: 'flex', sm: 'none' },
    alignItems: 'center',
    textTransform: 'capitalize',
    color: '#90979E',
    textDecoration: 'none ',
    margin: '0',
    padding: '0',
    fontSize: '12px',
    marginBottom: '5px',
    cursor: 'pointer',
    '& svg': {
      height: '11px',
    },
  },
  link: {
    textDecoration: 'none',
  },
  headerTitle: {
    marginBottom: '0px !important',
    display: 'flex',
    alignItems: { xs: 'center', md: 'flex-end' },
    gap: '5px',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: { xs: 'flex-start', sm: 'space-between' },
    height: '40px',
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    backgroundColor: '#FFF',
    p: { xs: 1, sm: '5px 30px 15px' },
  },
  backSvg: {
    position: 'fixed',
    unset: 0,
    zIndex: -1,
  },
}

export default Index
